import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid,
} from "recharts";
import { ChartCard } from "../../../components/ChartCard";
import type { FilterPillSpec } from "../../../components/FilterPills";
import { PRIMARY, MUTED } from "../../../lib/funnel/theme";
import { fmtDateShort } from "../../../lib/funnel/helpers";
import type { Entity } from "../helpers";

export type TrendPoint = { label: string; value: number };

export function WauTrend({
  data,
  entity,
  pagePills,
}: {
  data: TrendPoint[];
  entity: Entity;
  pagePills: FilterPillSpec[];
}) {
  const noun = entity === "user" ? "users" : "companies";
  const subtitle = `Distinct active ${noun} per week (Mon to Sun), last ~12 weeks.`;
  const points = data.map((d) => ({ ...d, displayLabel: fmtDateShort(d.label) }));
  return (
    <ChartCard title="Weekly Active Users trend" subtitle={subtitle} filterPills={pagePills}>
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={points} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(0,0,0,0.05)" vertical={false} />
          <XAxis dataKey="displayLabel" tick={{ fontSize: 10, fill: MUTED }} interval="preserveStartEnd" />
          <YAxis tick={{ fontSize: 10, fill: MUTED }} allowDecimals={false} width={32} />
          <Tooltip
            cursor={{ stroke: "rgba(0,0,0,0.08)" }}
            formatter={(v) => [String(v), `Active ${noun}`] as [string, string]}
          />
          <Line
            type="monotone"
            dataKey="value"
            stroke={PRIMARY}
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4 }}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
